import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const backgroundUrl = 'https://images.unsplash.com/photo-1512436991641-6745cdb1723f?auto=format&fit=crop&w=1500&q=80';

const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password.length < 6) {
      setError('Password must be at least 6 characters.');
      return;
    }
    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }
    setError('');
    setSuccess(true);
    setTimeout(() => navigate('/login'), 2000);
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center relative overflow-hidden">
      <img src={backgroundUrl} alt="Background" className="absolute inset-0 w-full h-full object-cover z-0" />
      <div className="absolute inset-0 bg-black/60 z-0" />
      <div className="relative z-10 max-w-md w-full mx-auto rounded-3xl shadow-2xl backdrop-blur-md bg-white/30 border border-white/30 p-8 flex flex-col items-center">
        <h1 className="text-3xl sm:text-4xl font-extrabold text-pink-600 mb-2 tracking-wide">theVastra.store</h1>
        <h2 className="text-2xl font-bold text-gray-900 mb-2 text-center drop-shadow">Reset Password</h2>
        {success ? (
          <div className="text-center text-green-600 font-semibold text-lg mt-6">
            Password reset successful!<br />Redirecting to <span className="underline">Login</span>...
          </div>
        ) : (
          <form className="w-full space-y-5" onSubmit={handleSubmit}>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              className="w-full px-4 py-3 rounded-xl border border-gray-300 bg-white/80 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-2 focus:ring-pink-400 focus:border-pink-400 text-base shadow"
              placeholder="New Password"
              required
            />
            <input
              type="password"
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
              className="w-full px-4 py-3 rounded-xl border border-gray-300 bg-white/80 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-2 focus:ring-pink-400 focus:border-pink-400 text-base shadow"
              placeholder="Confirm Password"
              required
            />
            {error && <div className="text-red-500 text-sm text-center">{error}</div>}
            <button
              type="submit"
              className="w-full py-3 rounded-xl bg-gradient-to-r from-pink-500 to-indigo-500 text-white font-semibold text-lg shadow hover:from-pink-600 hover:to-indigo-600 transition"
            >
              Reset Password
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ResetPassword; 